import ModalBladePatternCompare from "./ModalBladePatternCompare";
export default ModalBladePatternCompare;
